import { Injectable } from '@angular/core';
import { BaseRepository } from './base.repository';

@Injectable({
  providedIn: 'root'
})

export class InternationalHotelsRepository extends BaseRepository {
    getInternationalHotels() {
        return this.get(`${this.baseUrl}international-hotels`)
    }
    getIranlHotels() {
        return this.get(`${this.baseUrl}iranhotels`)
    }
}